import styled from 'styled-components';

const FormContainer = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  padding: ${props => props.containerPadding || '33px 40px'};
  background-color: ${props => props.backgroundColor};
  box-shadow: ${props => (props.shadow ? 'rgba(160,161,188,.35)' : 'none')};

  .signup-form--form {
    .ant-form-item {
      margin-bottom: 16px;

      button {
        margin-top: 8px;
      }
    }
  }

  .signup-form--footer,
  .signup-form--footer-1 {
    font-family: 'Sofia Pro';
    font-size: 16px;
    font-weight: 300;
    line-height: 26px;
    color: grey;

    & > a {
      color: grey;
      text-decoration: underline;
    }
  }

  .radio-field--title {
    color: var(--neutral-text-color);
  }
  .radio-field-wrapper {
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 10px;
  }
  .radio-div {
    color: var(--neutral-text-color);
    background-color: transparent;
    float: none;

    &:last-child label,
    label {
      border: 1px solid #cfd8dc;
    }
    &.selected label,
    input:checked + label,
    &.selected:last-child label {
      border: 3px solid var(--input-selected-color);
    }
  }
  .text-field-wrapper .text-field-input,
  .ant-select .ant-select-selection-rendered,
  .ant-select .ant-select-selection-placeholder {
    font-size: ${props => props.fontSize || '20px'} !important;
  }

  .slick-prev {
    left: 5px;
    position: relative;
    z-index: 10;
    top: 14px;
    &:before {
      border: solid black;
      border-width: 0 3px 3px 0;
      display: inline-block;
      padding: 9px;
      content: '';
      transform: rotate(135deg);
      -webkit-transform: rotate(135deg);
    }
  }

  @media (max-width: 768px) {
    padding: 24px 16px;

    .signup-form--title {
      font-size: 23px;
      letter-spacing: -0.02em;
    }

    .signup-form--form {
      .ant-form-item {
        button {
          margin-top: 0;
        }
      }
    }

    .text-field-wrapper .text-field-input,
    .ant-select .ant-select-selection-rendered,
    .ant-select .ant-select-selection-placeholder {
      font-size: 16px !important;
    }
  }

  @media (max-width: 576px) {
    padding: 20px 24px;

    .signup-form--form {
      .signup-form--submit-button {
        padding: 8px 24px;
        font-size: 16px;
        width: 100%;
      }
    }
  }
`;

const FormTitle = styled.p`
  font-family: Sofia Pro;
  font-size: ${props => props.titleSize || '36px'};
  font-weight: 600;
  line-height: 43px;
  letter-spacing: -0.04em;
  color: ${props => props.titleColor};
  padding: 0;
  margin: 0 0 24px;

  @media (max-width: 576px) {
    font-size: 28px;
    line-height: 26px;
  }
`;

const FormStep = styled.div`
  margin-top: 10px;
`;

export { FormContainer, FormTitle, FormStep };
